/**
 * @generated SignedSource<<26de0a164014c276b1b6256e291f3a59>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LoomFeedListQuery$variables = {
  isEnabled: boolean;
  loomSiteAri: string;
};
export type LoomFeedListQuery$data = {
  readonly loom_workspaceTrendingVideos?: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LoomFeedCardFragment">;
  } | null> | null;
};
export type LoomFeedListQuery = {
  response: LoomFeedListQuery$data;
  variables: LoomFeedListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loomSiteAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "loomSiteAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "LoomFeedListQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "LoomVideo",
            "kind": "LinkedField",
            "name": "loom_workspaceTrendingVideos",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "LoomFeedCardFragment"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoomFeedListQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "LoomVideo",
            "kind": "LinkedField",
            "name": "loom_workspaceTrendingVideos",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "picture"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  },
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "url"
              },
              {
                "kind": "ScalarField",
                "name": "playableDuration"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "fc0984e6b2d28ca53b6168237826facb",
    "id": null,
    "metadata": {},
    "name": "LoomFeedListQuery",
    "operationKind": "query",
    "text": "query LoomFeedListQuery(\n  $loomSiteAri: ID!\n  $isEnabled: Boolean!\n) {\n  loom_workspaceTrendingVideos(id: $loomSiteAri) @include(if: $isEnabled) {\n    id\n    ...LoomFeedCardFragment\n  }\n}\n\nfragment LoomFeedCardFragment on LoomVideo {\n  name\n  owner {\n    __typename\n    name\n    picture\n    accountId\n    id\n  }\n  url\n  playableDuration\n}\n"
  }
};
})();

(node as any).hash = "facebbda706d015b725adf660830d9ea";

export default node;
